/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/view-article-details-info/shop.view-article-details-info.component.ts.
 */
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BehaviorSubject, Subscription} from 'rxjs';
import {AppPageloaderService} from '../../../../services/app.pageloader.service';
import {AppViewService} from '../../../../services/app.view.service';
import {Artikel} from '../../../../models/artikel';
import {View} from '../../../../models/view';
import {ArtikelInfo} from '../../../../models/artikel-info';
import {AppArticleInfoService} from '../../../../services/app.article-info.service';
import {HttpErrorResponse} from '@angular/common/http';
import {DownloadedFile} from '../../../../models/downloaded-file';
import {AppAsyncTimeout} from '../../../../helpers/app.asyncTimeout';

/**
 * Zweck: Beschreibt class ShopViewArticleDetailsInfoComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'shop-view-article-details',
    templateUrl: 'shop.view-article-details-info.component.html',
    styleUrls: ['shop.view-article-details-info.component.scss'],
    standalone: false
})
export class ShopViewArticleDetailsInfoComponent implements OnInit, OnDestroy {
  slug: string;
  artid: string;
  infoid: number;

  show_pdf_viewer = false;
  current_file: DownloadedFile;
  @ViewChild('pdfViewer') pdfViewer: any;
  @ViewChild('pdfviewerdiv') pdfviewerdiv: any;


  view: View;

  article_info: BehaviorSubject<ArtikelInfo> = new BehaviorSubject<ArtikelInfo>(null);

  rsub: Subscription;

  article = new BehaviorSubject<Artikel>(null);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private route: ActivatedRoute, private loader: AppPageloaderService, private svc: AppViewService,
              private isvc: AppArticleInfoService) {
  }

/**
 * Beschreibt Methode onAllReady und ihren Rückgabevertrag.
 */
  onAllReady(fkt) {
    if (this.pdfviewerdiv) {
      fkt();
    } else {
      AppAsyncTimeout.setTimeout(() => {
        this.onAllReady(fkt);
      }, 50);
    }
  }

/**
 * Beschreibt Methode download und ihren Rückgabevertrag.
 */
  download() {
    if (this.article_info.value.file && this.article_info.value.file.mimetype == 'application/pdf') {
      this.show_pdf_viewer = true;

      AppAsyncTimeout.setTimeout(() => {
        const l = this.loader.start();
        this.isvc.getPDF(this.article_info.value).subscribe(file => {
          this.current_file = file;
          this.pdfViewer.pdfSrc = this.current_file.data; // pdfSrc can be Blob or Uint8Array
          this.pdfViewer.downloadFileName = this.current_file.filename;
          this.pdfViewer.refresh(); // Ask pdf viewer to load/reresh pdf

          this.onAllReady(() => {
            this.updateHeight();
          });


          l.stop();

        }, (r: HttpErrorResponse) => {
          const me = this;
          const reader = new FileReader();
          reader.onload = function () {
            console.log(reader.result);
            // me.error = reader.result;
          };
          reader.readAsText(r.error);
          l.stop();
        });

      }, 50);

    } else {
      const l = this.loader.start();
      this.isvc.getFile(this.article_info.value).subscribe(() => {
        l.stop();
      });
    }
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    if (this.slug && this.artid && this.infoid) {
      this.article.next(null);
      this.view = this.svc.getViewBySlug(this.slug);
      const l = this.loader.start();
      this.svc.getOneById(this.slug, this.artid).subscribe(art => {
        l.stop();
        this.article.next(art);
        art.infos.forEach(is => {
          if (is.id == this.infoid) {
            this.article_info.next(is);
          }
        });
      }, () => {
        l.stop();
      });
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    if (this.rsub instanceof Subscription) {
      this.rsub.unsubscribe();
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.route.parent.params.subscribe(p => {
      this.slug = p['slug'];

      this.load();
    });
    this.rsub = this.route.params.subscribe(p => {
      this.artid = p['artid'];
      this.infoid = p['infoid'];

      this.load();
    });
  }

  private updateHeight() {
    const height = window.innerHeight - this.pdfviewerdiv.nativeElement.offsetTop - 30;

    this.pdfviewerdiv.nativeElement.style.height = height + 'px';
  }


}
